/** Tipos de evidencia PDF en captura mensual (compliance instances). */

export const COMPLIANCE_EVIDENCE_DOC_TYPES = [
  { value: "provisional_normal", label: "Declaración provisional / normal" },
  { value: "normal_otros_impuestos", label: "Normal — otros impuestos" },
  { value: "complementaria_normal", label: "Última complementaria (normal)" },
  { value: "complementaria_otros_impuestos", label: "Última complementaria (otros impuestos)" },
  { value: "anual", label: "Anual" },
  { value: "informativa", label: "Informativa" },
  { value: "sipare", label: "SIPARE" },
  { value: "acuse_pago", label: "Acuse de pago" },
  { value: "otro", label: "Otro PDF" },
];

/** Impuestos que suelen ir juntos en una misma declaración provisional SAT. */
export const SHARED_DECLARATION_HINT_CATALOG_IDS = new Set([
  "sat_iva_mensual",
  "sat_isr_mensual",
  "sat_isr_resico_pf",
  "sat_isr_resico_pm",
  "sat_isr_act_empresarial",
  "sat_isr_arrendamiento",
  "sat_iva_arrendamiento",
  "sat_ret_isr",
  "sat_ret_iva",
  "sat_ret_honorarios",
]);

export function complianceEvidenceDocTypeLabel(value) {
  const found = COMPLIANCE_EVIDENCE_DOC_TYPES.find((o) => o.value === value);
  return found?.label || value || "—";
}

export function formatEvidenceSize(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

/** Badge / tono según parseo del PDF. */
export function evidenceParseTone(parse) {
  if (!parse) return "muted";
  if (parse.rfc_match === false) return "danger";
  if (parse.period_match === false) return "warn";
  if (parse.parse_status === "ok" && parse.rfc_match === true) return "ok";
  if (parse.parse_status === "no_text" || parse.parse_status === "error") return "warn";
  if (parse.summary_lines?.length) return "info";
  return "muted";
}

export function evidenceParseHeadline(parse) {
  if (!parse) return "";
  if (parse.rfc_match === false) return "RFC no coincide con el cliente";
  if (parse.rfc_match === true && parse.period_match === false) {
    return "RFC correcto · periodo distinto al mes";
  }
  if (parse.rfc_match === true) return "RFC coincide con el cliente";
  if (parse.parse_status === "no_text") return "Sin texto legible en el PDF";
  if (parse.summary_lines?.length) return "Resumen detectado (revise)";
  return "Sin datos automáticos";
}

const PARSE_TONE_CLASS = {
  ok: "border-emerald-200 bg-emerald-50 text-emerald-900",
  warn: "border-amber-200 bg-amber-50 text-amber-950",
  danger: "border-red-200 bg-red-50 text-red-900",
  info: "border-sky-200 bg-sky-50 text-sky-950",
  muted: "border-slate-200 bg-slate-50 text-slate-700",
};

export function evidenceParseToneClass(parse) {
  return PARSE_TONE_CLASS[evidenceParseTone(parse)] || PARSE_TONE_CLASS.muted;
}

export function buildShareSiblingOptions(currentItem, allItems = []) {
  const currentId = String(currentItem?.id || "");
  return (allItems || [])
    .filter((item) => item?.id && String(item.id) !== currentId)
    .map((item) => ({
      id: item.id,
      name: item.obligation_name || item.obligation_catalog_id || item.id,
      catalogId: item.obligation_catalog_id || "",
      suggested: SHARED_DECLARATION_HINT_CATALOG_IDS.has(String(item.obligation_catalog_id || "")),
    }));
}

export function defaultShareSelection(siblings = [], docType = "") {
  const provisional = ["provisional_normal", "complementaria_normal", "normal_otros_impuestos"].includes(docType);
  if (!provisional) return [];
  return siblings.filter((s) => s.suggested).map((s) => s.id);
}
